<template>
  <content-card :title="$t('charge-location-list.title')"
                icon="location_on">
    <template v-slot:titleBar>
      <v-icon v-if="chargeLocations.length > 0" class="add_location_icon material-icons-outlined"
              color="primary" @click="newLocation()">
        add_circle
      </v-icon>
    </template>
    <template v-slot:content>
      <v-skeleton-loader v-if="loading" type="article"
                         height="200"></v-skeleton-loader>
      <v-list v-if="!loading">
        <div v-show="store.sharedState.chargeLocations.length > 0">
          <v-list-item-group :value="modelValue" @change="updateModel" color="primary" mandatory v-show="selectable">
            <v-list-item class="mx-2" v-for="(location, i) in store.sharedState.chargeLocations" :key="i">
              <v-list-item-icon>
                <v-icon color="primary">location_on</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ location.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary" @click.stop="editLocation(location)">edit</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
          <v-list-item v-show="!selectable" class="mx-2" v-for="(location, i) in store.sharedState.chargeLocations"
                       :key="i">
            <v-list-item-icon>
              <v-icon color="primary">location_on</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ location.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary" @click.stop="editLocation(location)">edit</v-icon>
            </v-list-item-action>
          </v-list-item>
        </div>
        <v-list-item class="mx-2" v-show="store.sharedState.chargeLocations.length === 0" @click="newLocation">
          <v-list-item-content>
            <v-list-item-title>{{ $t('charge-location-list.create-first-location') }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="primary">add_circle</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </template>
  </content-card>
</template>

<script>
import ContentCard from "@/templates/components/ContentCard.vue";
import store from "enode-lib/src/store"

export default {
  name: "ChargeLocationsList",
  components: {ContentCard},
  props: ['vehicleId', 'originDialog', 'modelValue', 'selectable', 'originData'],
  data() {
    return {
      chargeLocations: store.sharedState.chargeLocations,
      loading: false,
      store: store
    };
  },
  methods: {
    editLocation(location) {
      this.$root.bisadialog.toggle(this.originDialog, false);
      this.$root.bisadialog.toggle("location", true, {
        location,
        vehicleId: this.vehicleId,
        originDialog: this.originDialog,
        originData: this.originData
      });
      this.$root.bisadialog.callDialogInit("location");
    },
    newLocation() {
      this.$root.bisadialog.toggle(this.originDialog, false);
      this.$root.bisadialog.toggle("location", true, {
        vehicleId: this.vehicleId,
        originDialog: this.originDialog,
        originData: this.originData
      });
    },
    updateModel(event) {
      if (this.chargeLocations.length > 0) {
        this.$emit('input', this.chargeLocations[event]?.id)
      }
    },
    mounted() {
      if (this.chargeLocations.length > 0) {
        this.$emit('input', this.chargeLocations[0]?.id)
      }
    }
  },
}
</script>

<style>
@import "@/styles/charge-location-list.scss";
</style>